/** Polite live-region announcer. Appends a hidden node to #vq-portal-root
 *  with `aria-live="polite"`, writes the message, then clears it after a
 *  short interval so the next identical message still triggers speech.
 *  SSR-safe: a no-op when `document` is absent. */

let node: HTMLElement | null = null;
let clearTimer: number | null = null;

function ensureNode(): HTMLElement | null {
  if (typeof document === 'undefined') return null;
  if (node !== null && document.body.contains(node)) return node;
  const el = document.createElement('div');
  el.setAttribute('aria-live', 'polite');
  el.setAttribute('aria-atomic', 'true');
  // Visually hidden but reachable by screen readers.
  el.style.cssText =
    'position:absolute;width:1px;height:1px;padding:0;margin:-1px;' +
    'overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
  document.body.appendChild(el);
  node = el;
  return el;
}

export function announce(message: string): void {
  const el = ensureNode();
  if (el === null) return;
  if (clearTimer !== null) window.clearTimeout(clearTimer);
  // Force a re-announce even if the message is identical by clearing first.
  el.textContent = '';
  window.setTimeout(() => {
    el.textContent = message;
  }, 10);
  clearTimer = window.setTimeout(() => {
    el.textContent = '';
    clearTimer = null;
  }, 1500);
}
